import {BrowserRouter,Routes,Route} from 'react-router-dom';
import {lazy,Suspense } from 'react';
import PrivateRoute from './service/PrivateRoute';
import RoleSelector from './pages/RoleSelector';
import ErrorBoundary from './service/ErrorBoundary';
const Login = lazy(()=>import('./pages/login'));
const Home = lazy(()=>import('./component/home/index'))



function App() {
  
  return (
  
      <BrowserRouter>
        <ErrorBoundary>
        <Suspense fallback={<div className="loader">
                <img src="/assets/images/Loader_bg.gif" alt="Loading..." />
            </div>}>
          <Routes>
              <Route path='/' element={<Login/>} >Location</Route>
              <Route path='/home/*' element={<Home/>} >Home</Route>
              <Route path='/login' element={<Login/>} >Location</Route>
              <Route path='/select-role' element={<PrivateRoute><RoleSelector /></PrivateRoute>}>Role Selector</Route>
          </Routes>
        </Suspense> 
        </ErrorBoundary>
      </BrowserRouter>
  );
}

export default App;
